<template>
  <BasePortalIcon
    :class="`text-${LeadStatusColor.Primary}`"
    class="me-1"
    icon="leo"
    width="1rem"
    height="1rem"
  />
</template>

<script lang="ts" setup>
import { LeadStatusColor } from '@/shared'
</script>
